// extracted by mini-css-extract-plugin
export default {"app":"Layout_app__8nJ+1","main":"Layout_main__FxQfo"};